@if (!(layoutService.isDesktopView | async)) {
  <div>
    <div class="atlas-panel-header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="atlas-panel-header-description">
      <ng-content select="[description]"></ng-content>
    </div>
  </div>
}
